import BaseStep from './BaseStep.js';
import {PhoneNumberField} from "../PhoneNumberField.js";
export default class SignUpStep extends BaseStep{
	#needUserValidation = false;

	#canResendCode = false;
	#currentFieldIndex = 0;
	#validationCheckSent = false;
	#validation_nonce = '';
	#resend_email_nonce = '';

    _init() {
		this._MultiStepForms.Hook.addAction('addWatchers', () => {
			this.#initPhoneCodes();
			this.#initPasswordFields();
			this.#initCountryChange();
		});

		this._MultiStepForms.Hook.addAction('addEvents', () => {
			this.#addEvents();
		})

		const disable_2fa = document.querySelector("input[name=disable_2fa]")
		if (!disable_2fa?.value) {
			this._MultiStepForms.Hook.addAction('submitFormSuccess', (response, form, formAction) => {
				if (formAction === 'levcharity_create_user') {
					if (response?.wait_for_validation_code) {
						this.#needUserValidation = true;

						this.#initConfirmationModal(response);
					}
				}
			})
		}else {
			this._MultiStepForms.Hook.addAction('submitFormSuccess', (response, form, formAction) => {
				if (formAction === 'levcharity_create_user') {
					const titleWrapper = document.querySelector('.campaign-title.auto_generate');
					if(titleWrapper){
						setTimeout(() => {
						const userForm = document.querySelector('form.create-user');
						if (userForm) {
							const firstName = userForm.querySelector('input[name="first_name"]').value;
							const lastName = userForm.querySelector('input[name="last_name"]').value;
							const campaignTitleInput = titleWrapper.querySelector('.form-control[id$="campaign_title"]');
							if (firstName && lastName && campaignTitleInput) {

								const template = '{first name} {last name}’s campaign';
								const campaignTitle = template
									.replace('{first name}', firstName)
									.replace('{last name}', lastName);

								campaignTitleInput.value = campaignTitle;
							}
						}
						}, 300);
					}
				}
			})
		}

		this._MultiStepForms.Hook.addFilter('doNextStep' , (doNextStep, currentStep, nextStep) => {
			if (this.#needUserValidation) {
				return false;
			}
			return doNextStep;
		}, 10)
    }

	#initPhoneCodes() {
		new PhoneNumberField();
	}

    #initPasswordFields() {
		this._MultiStepForms.handleEvent('click', '.form-group .show-hide-password', (event, element) => {
			const formGroup = element.closest('.form-group');
			const input = formGroup.querySelector('input');

			if (!input) return;

			if (input.type === 'password') {
				input.type = 'text';
			} else {
				input.type = 'password';
			}

		});

		this._MultiStepForms.handleEvent('input', 'input[data-type=password]', (event, password) => {
			const passwordValidationWrapper = password.closest('form')?.querySelector('.password-validation-wrapper');

			if (!passwordValidationWrapper) return;

			const letterRegex = /[a-zA-Z]/;
			const numberRegex = /\d/;
			const symbolRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?/~\\\-=`]/;

			if (letterRegex.test(password.value)) {
				passwordValidationWrapper.querySelector('.letter')?.classList.add('valid');
			} else {
				passwordValidationWrapper.querySelector('.letter')?.classList.remove('valid');
			}

			if (numberRegex.test(password.value)) {
				passwordValidationWrapper.querySelector('.number')?.classList.add('valid');
			} else {
				passwordValidationWrapper.querySelector('.number')?.classList.remove('valid');
			}

			if (symbolRegex.test(password.value)) {
				passwordValidationWrapper.querySelector('.symbol')?.classList.add('valid');
			} else {
				passwordValidationWrapper.querySelector('.symbol')?.classList.remove('valid');
			}

			if (password.value.length >= 7) {
				passwordValidationWrapper.querySelector('.length')?.classList.add('valid');
			} else {
				passwordValidationWrapper.querySelector('.length')?.classList.remove('valid');
			}
		});
    }

    #initCountryChange(){
		this._MultiStepForms.handleEvent('change', 'select[name="billing_country"]', (event, country_select) => {
			const form = country_select.closest('form');
			const country_code = country_select.value?.toLowerCase() || '';
			const state_fields = form?.querySelectorAll('[name="billing_state"]');

			const hasCountryStatesSelect = country_code && [...state_fields].some(element => element.id && element.id.includes(`-${country_code}-`));

			state_fields?.forEach((el, index) => {
				if (hasCountryStatesSelect) {
					if (el.id.includes(`-${country_code}-`)) {
						el.disabled = false;
						el.style.display = '';
					} else {
						el.disabled = true;
						el.style.display = 'none';
					}
				} else {
					if (index === 0){
						el.disabled = false;
						el.style.display = '';
					} else {
						el.disabled = true;
						el.style.display = 'none';
					}
				}
			});
		});
    }

	#addEvents() {
		let fieldLastValue = '';
		this._MultiStepForms.handleEvent('input,keydown', '.levcharity_email_confirmation_modal_wrapper .fields input[type="text"]', (event, field) => {
			if (field.value && !/^\d+$/.test(field.value)) {
				event.preventDefault();
				field.value = '';
				return;
			}

			const fields = [...field.closest('.fields').querySelectorAll('input[type="text"]')];
			const currentIndex = fields.indexOf(field);
			const isBackspace = event.type === 'keydown' && event.key === 'Backspace';
			const ctrlKey = isBackspace && event.ctrlKey;

			let isFilled = false;

			if (!isBackspace && fieldLastValue === field.value){
				return;
			}

			this._MultiStepForms.clearErrors();

			if (ctrlKey) {
				fields.forEach(f => {
					f.value = '';
				});

				this.#currentFieldIndex = 0;
				fields[0].focus();

				return;
			}

			if (field.value.length > 1 && field.value.length !== 6){
				field.value = '';
				return;
			} else if (field.value.length === 6 && currentIndex === 0) {
				for (let i = 0; i < field.value.length; i++) {
					if (currentIndex !== i ) {
						fields[i].value = field.value[i];
					}
				}

				isFilled = true;

				fields[field.value.length - 1].focus();
			}

			if (isBackspace && !field.value.length && fields[currentIndex - 1]) {
				fields[currentIndex - 1].focus()
				fields[currentIndex - 1].value = '';
				this.#currentFieldIndex = currentIndex - 1;
			} else if (field.value.length === 1 && fields[currentIndex + 1]) {
				fields[currentIndex + 1].focus()
				this.#currentFieldIndex = currentIndex + 1;
			}

			if (field.value.length > 1) {
				event.preventDefault();
				field.value = field.value[0];
			}

			fieldLastValue = field.value;

			if (field === fields[fields.length - 1] || isFilled) {
				let fieldsValue = '';

				for (const f of fields) {
					fieldsValue += f.value;
				}

				if (fieldsValue.length === 6) {
					this.#checkValidationCode(field.closest('form'), fields, fieldsValue);
				}
			}
		});

		this._MultiStepForms.handleEvent('click,keydown', '.levcharity_email_confirmation_modal_wrapper .fields input[type="text"]', (event, field) => {
			const fields = [...field.closest('.fields').querySelectorAll('input[type="text"]')];
			const currentIndex = fields.indexOf(field);
			const isTabPressed = event.type === 'keydown' && event.key === 'Tab';

			if (currentIndex !== this.#currentFieldIndex || isTabPressed) {
				event.preventDefault();

				fields[this.#currentFieldIndex].focus();
			}
		})

		this._MultiStepForms.handleEvent('click', '.levcharity_email_confirmation_modal_wrapper .resend_code', (event, link) => {
			event.preventDefault();

			if (!this.#canResendCode) return;

			const form = link.closest('form');

			const tempForm = document.createElement('form');
			tempForm.innerHTML = `<input type="hidden" name="nonce" value="${this.#resend_email_nonce}">`;

			form.classList.add('doing-ajax');

			this._MultiStepForms.clearErrors();

			this._MultiStepForms.submitForm(tempForm, 'levcharity_resend_signup_email_validation_code', false)
				.then(response => {
					this.#initResendCountdown(link);

					if (response?.nonce) {
						this.#resend_email_nonce = response.nonce;
					}
				})
				.catch(response => {
					if (response && !response.success && response.message) {
						this._MultiStepForms.error(null, response.message, form, false);
					} else {
						this._MultiStepForms.error(null, wp.i18n.__('Something went wrong. Please try again.', 'levcharity'), form, false);
					}

					if (response?.nonce) {
						this.#resend_email_nonce = response.nonce;
					}
				})
				.finally(() => {
					form.classList.remove('doing-ajax');
				})
		})

		this._MultiStepForms.handleEvent('click' ,'.levcharity_email_confirmation_modal_wrapper .close', (event, button) => {
			event.preventDefault();

			const modalWrapper = button.closest('.levcharity_email_confirmation_modal_wrapper');
			modalWrapper.classList.remove('show');

			setTimeout(() => {
				modalWrapper.remove();
			}, 300)
		});
	}

	#initConfirmationModal(response) {
		const formStep = this._MultiStepForms.formSteps[this._MultiStepForms.currentStep - 1];
		let modalWrapper = formStep.querySelector('.levcharity_email_confirmation_modal_wrapper');

		this.#validation_nonce = response.validation_nonce;
		this.#resend_email_nonce = response.resend_email_nonce;

		if (!modalWrapper) {
			modalWrapper = document.createElement('div');
			modalWrapper.classList.add('levcharity_email_confirmation_modal_wrapper');

			modalWrapper.innerHTML = `
				<form class="levcharity_email_confirmation_modal">
					<a href="#" class="levcharity_button remove close"></a>
					<h5 class="levcharity_heading"></h5>
					<div class="levcharity-errors-container"></div>
					<div class="fields">
						<input type="text" placeholder="1">
						<input type="text" maxlength="1" placeholder="2">
						<input type="text" maxlength="1" placeholder="3">
					<span class="separator">-</span>
						<input type="text" maxlength="1" placeholder="4">
						<input type="text" maxlength="1" placeholder="5">
						<input type="text" maxlength="1" placeholder="6">
					</div>
					<a class="resend_code" href="#"></a>
				</form>
			`

			modalWrapper.style.display = 'none';

			formStep.append(modalWrapper);
		}

		const resendLink = modalWrapper.querySelector('.resend_code');
		const title = modalWrapper.querySelector('.levcharity_heading');

		title.textContent = wp.i18n.__(`We have sent email to ${response.email}`, 'levcharity');

		modalWrapper.style.display = '';

		setTimeout(() => {
			modalWrapper.classList.add('show');
			modalWrapper.querySelector('.fields input[type="text"]').focus();
		}, 10);

		this.#initResendCountdown(resendLink);
	}

	#checkValidationCode(form, fields, value) {
		if (form && !this.#validationCheckSent) {
			this.#validationCheckSent = true
			const codeField = document.createElement('input');
			const nonceField = document.createElement('input');
			codeField.type = 'hidden';
			codeField.name = 'code';
			codeField.value = value;
			nonceField.type = 'hidden';
			nonceField.name = 'nonce';
			nonceField.value = this.#validation_nonce;

			form.append(codeField);
			form.append(nonceField);

			form.classList.add('doing-ajax')

			this._MultiStepForms.submitForm(form, 'levcharity_check_signup_email_validation_code', false)
				.then(response => {
					if (response?.success){
						this.#needUserValidation = false;

						const modalWrapper = form.closest('.levcharity_email_confirmation_modal_wrapper');
						modalWrapper.classList.remove('show');

						const signUpForm = modalWrapper.closest('.step')?.querySelector('form') || null;

						setTimeout(() => {
							modalWrapper.remove();

							const titleWrapper = document.querySelector('.campaign-title.auto_generate')
							if(titleWrapper){
								const form = document.querySelector('form.create-user');
								if (form) {
									const firstName = form.querySelector('input[name="first_name"]').value;
									const lastName = form.querySelector('input[name="last_name"]').value;
									const campaignTitleInput = titleWrapper.querySelector('.form-control[id$="campaign_title"]');
									if (firstName && lastName && campaignTitleInput) {

										const template = '{first name} {last name}’s campaign';
										const campaignTitle = template
											.replace('{first name}', firstName)
											.replace('{last name}', lastName);

										campaignTitleInput.value = campaignTitle;
									}
								}
							}


							if (signUpForm) {
								signUpForm.querySelector('button.submit-form')?.click()
							}
						}, 300)
					}

					if (response?.nonce) {
						this.#validation_nonce = response.nonce;
					}
				})
				.catch(response => {
					if (response && !response.success && response?.invalid_code) {
						form.classList.add('error');
						setTimeout(() => {
							form.classList.remove('error');
							fields.forEach(f => f.value = '');
							fields[0].focus();
							this.#currentFieldIndex = 0;
						}, 400);
					} else if (response && !response.success && response.message) {
						this._MultiStepForms.error(null, response.message, form, false);
						fields.forEach(f => f.value = '');
						fields[0].focus();
						this.#currentFieldIndex = 0;
					} else {
						this._MultiStepForms.error(null, wp.i18n.__('Something went wrong. Please try again.', 'levcharity'), form, false);
						fields.forEach(f => f.value = '');
						fields[0].focus();
						this.#currentFieldIndex = 0;
					}

					if (response?.nonce) {
						this.#validation_nonce = response.nonce;
					}
				})
				.finally(() => {
					this.#validationCheckSent = false;
					codeField.remove();
					nonceField.remove();
					form.classList.remove('doing-ajax');
				})
		}
	}

	#initResendCountdown(resendLink){
		this.#canResendCode = false;

		let secondsLeft = 120;
		const resendCodeUpdatedText = () => `${wp.i18n.__('I didn\'t receive the code, please send again ' + ( secondsLeft ? '(' + secondsLeft + 's)' : '') , 'levcharity')}`;

		resendLink.textContent = resendCodeUpdatedText();
		resendLink.classList.add('disabled');

		const resendInterval = setInterval(() => {
			if (secondsLeft > 0) {
				secondsLeft--;
				resendLink.textContent = resendCodeUpdatedText();
			}

			if (secondsLeft <= 0) {
				resendLink.classList.remove('disabled');
				clearInterval(resendInterval);
				this.#canResendCode = true;
			}
		},1000)
	}
}
